export interface ProductPopularity {
  id: number;
  name: string;
  popularProductOrder?: number;
  highlightedProductOrder?: number;
  dailyPopularProductOrder?: number;
}

export const productPopularityFromResponse = (
  responseData: any,
): ProductPopularity => ({
  id: responseData.id,
  name: responseData.name,
  popularProductOrder: responseData.popular_product_order,
  highlightedProductOrder: responseData.highlighted_product_order,
  dailyPopularProductOrder: responseData.daily_popular_product_order,
});
